angular.module('iw.frontyard.signup')
    .service('SignupPage', function (SignupAPIHelper,
                                     IwocaSiteHelper,
                                     SignupEmailValidityRegExp,
                                     SignupLendingAPIHelper,
                                     $window) {

        const PRODUCT_TYPES = {
            DEFAULT: null,
            CREDIT_LINE: 'CREDIT_LINE',
            TERM_LOAN: 'TERM_LOAN',
        };

        class SignupPage {
            constructor() {
                this.setAsDefaultProduct();

                this.email = null;
                this.urgency = 0;
                this.requestedAmount = null;
                this.reason = null;
                this.detailedReason = null;
                this.showReasons = false;
                this.marketingEmails = false;
                this.personUID = SignupAPIHelper.generateUUID();
                this.emailUID = SignupAPIHelper.generateUUID();
                this.choices = SignupLendingAPIHelper.getChoices();
                this.selectedChoice = null;
                this.showExtraFields = false;
                this.showOtherReason = false;
                this.isPending = false;
                this.isPendingEmailValidity = false;
                this.isEmailValidForServer = null;
                this.serverVerifiedEmails = {};
                this.isInvalidOnCreateAccount = false;
                this.hasToValidateExtraFields = false;
                this.isCreateAccountEnabled = false;
                this.hasError = false;
                this.emailValidityRegExp = SignupEmailValidityRegExp;
            }

            setAsDefaultProduct() {
                this.duration = null;
                this.productType = PRODUCT_TYPES.DEFAULT;
                this.MIN_LOAN_SIZE = $window.MIN_LOAN_SIZE;
                this.MAX_LOAN_SIZE = $window.MAX_LOAN_SIZE;
                this.FORMATTED_MIN_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MIN_LOAN_SIZE);
                this.FORMATTED_MAX_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MAX_LOAN_SIZE);
            }

            setAsCreditLineProduct() {
                this.duration = 12;
                this.productType = PRODUCT_TYPES.CREDIT_LINE;
                this.MIN_LOAN_SIZE = $window.MIN_LOAN_SIZE;
                this.MAX_LOAN_SIZE = $window.MAX_LOAN_SIZE;
                this.FORMATTED_MIN_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MIN_LOAN_SIZE);
                this.FORMATTED_MAX_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MAX_LOAN_SIZE);
            }

            setAsTermLoanProduct() {
                this.duration = 60;
                this.productType = PRODUCT_TYPES.TERM_LOAN;
                // TODO: hard coded for min term loan size
                this.MIN_LOAN_SIZE = 5000;
                this.MAX_LOAN_SIZE = $window.MAX_LOAN_SIZE;
                this.FORMATTED_MIN_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MIN_LOAN_SIZE);
                this.FORMATTED_MAX_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MAX_LOAN_SIZE);
            }

            setAsApproveInFuture() {
                this.urgency = 1;
                this.showExtraFields = false;
                this.showReasons = false;
                this.updateCreateAccountValidity();
            }

            setAsNotUrgent() {
                this.urgency = 2;
                this.showExtraFields = true;
                this.updateCreateAccountValidity();
            }

            setAsUrgent() {
                this.urgency = 3;
                this.showExtraFields = true;
                this.updateCreateAccountValidity();
            }

            keyPressOnButtons(event) {
                if (event.keyCode === 39) {
                    switch (this.urgency) {
                        case 2:
                            this.setAsApproveInFuture();
                            break;
                        case 3:
                            this.setAsNotUrgent();
                            break;
                    }
                } else if (event.keyCode === 37) {
                    switch (this.urgency) {
                        case 1:
                            this.setAsNotUrgent();
                            break;
                        case 2:
                            this.setAsUrgent();
                            break;
                    }
                }
            }

            redirectToLogin() {
                IwocaSiteHelper.closeOverlay();
                IwocaSiteHelper.openLoginOverlay(this.email);
            }

            onClickSendEmails() {
                this.marketingEmails = !this.marketingEmails;
            }

            updateCreateAccountValidity() {
                this.isCreateAccountEnabled = this.isValid();
            }

            onEmailChange() {
                this.isEmailValidForServer = null;
                this.updateCreateAccountValidity();
            }

            onReasonChange(choice) {
                this.reason = choice.value;
                this.selectedChoice = choice.name
                this.showOtherReason = (choice.value === 'other');
                this.toggleReasons();
                this.updateCreateAccountValidity();
            }

            toggleReasons() {
                this.showReasons = !this.showReasons;
            }

            blurReasons() {
                this.blurOtherReasons = true;
            }

            openReasons() {
                this.blurOtherReasons = false;
                this.showReasons = true;
            }

            isValid() {
                switch (this.urgency) {
                    case 1:
                        return this.isValidForApprovalInFuture();
                    default:
                        return this.isValidForApproval();
                }
            }

            isValidForApprovalInFuture() {
                return this.isValidEmail()
                    && this.isEmailValidForServer !== false
                    && this.isValidRequestedAmount()
                    && this.urgency === 1;
            }

            isValidForApproval() {
                return this.isValidEmail()
                    && this.isEmailValidForServer !== false
                    && this.isValidRequestedAmount()
                    && this.isValidReason()
                    && this.urgency > 1;
            }

            isValidReason() {
                if (this.isValidReasonAsOther()) {
                    return true;
                } else if (this.isValidReasonAsSelectedChoice()) {
                    return true;
                }
                return false;
            }

            isValidReasonAsSelectedChoice() {
                return angular.isDefined(this.reason)
                    && this.reason !== null
                    && this.reason !== 'other';
            }

            isValidReasonAsOther() {
                return this.reason === 'other'
                    && angular.isString(this.detailedReason)
                    && this.detailedReason.length > 0;
            }


            isValidEmail() {
                return angular.isString(this.email)
                    && this.emailValidityRegExp.test(this.email)
                    && !!this.serverVerifiedEmails[this.email];
            }

            isValidRequestedAmount() {
                return angular.isNumber(this.requestedAmount)
                    && this.requestedAmount > 0
                    && this.requestedAmount <= this.MAX_LOAN_SIZE;
            }

            validateRequestedAmount() {
                this.isValidatedRequestedAmount = true;
                this.form.requested_amount.$validate();
            }

            validateSingleInput(fieldName) {
                //TODO: deprecated
                this.form[fieldName].$validate();
            }

            checkEmailValidity() {
                var self = this;

                if (!self.form.email.$invalid) {
                    self.isPendingEmailValidity = true;
                    SignupAPIHelper.isValidEmail(self.email)
                        .then(function onSuccess(response) {
                            self.isEmailValidForServer = response.data;
                            self.serverVerifiedEmails[self.email] = response.data;
                        }, function onError() {
                            self.isEmailValidForServer = null;
                            self.serverVerifiedEmails[self.email] = false;
                        })
                        .finally(function () {
                            self.isPendingEmailValidity = false;
                            self.updateCreateAccountValidity();
                        });
                } else {
                    self.isPendingEmailValidity = false;
                    self.isValidatedEmail = true;
                    self.form.email.$validate();
                }
            }

            createAccount() {
                if (this.isValid()) {
                    this.isInvalidOnCreateAccount = false;
                    this.hasToValidateExtraFields = false;

                    this.createAccountAndRedirect();
                } else {
                    this.isInvalidOnCreateAccount = true;
                    this.checkEmailValidity();

                    if (this.showExtraFields) {
                        this.hasToValidateExtraFields = true;
                    }
                }
            }

            createAccountAndRedirect() {
                var self = this;

                self.isPending = true;
                var content = {data: SignupAPIHelper.serializeDataToSend(self)};

                SignupAPIHelper.postData(content)
                    .then(function onSuccess(response) {
                        var url = SignupLendingAPIHelper.getSignupURL();
                        self.hasError = false;
                        IwocaSiteHelper.redirectToInternalPage(url);
                    }, function onError(response) {
                        self.hasError = true;
                    })
                    .finally(function () {
                        self.isPending = false;
                    });
            }
        }

        return new SignupPage();
    });
